import { Injectable, OnDestroy } from "@angular/core";
import { PaymentService } from "./payment.service";
import { LocalstorageService } from "./localstorage.service";
import { concatMap, delay, from, mergeMap, of, Subject, Subscription, tap, timer } from "rxjs";
import { AuthService } from "./auth.service";
import { ReceiptService } from "./receipt.service";
import { FeatureService } from "./feature.service";
import { MqService } from "./mq.service";
import { printz } from "./utils";
import {PrinterConfigService} from "./printer-config.service";
import {OrderItem} from "./gen";
import OrderTypeEnum = OrderItem.OrderTypeEnum;

@Injectable({ providedIn: "root" })
export class KitchenService implements OnDestroy {
  incomingOrder$: Subject<void> = new Subject<void>();
  incomingOrderTimer$: Subscription;
  prepareTypeEnum = [OrderTypeEnum.DineIn, OrderTypeEnum.TakeAway];

  constructor(
    private customPaymentService: PaymentService,
    private ls: LocalstorageService,
    private authService: AuthService,
    private receiptService: ReceiptService,
    private fs: FeatureService,
    private mqs: MqService,
    private printerConfigService: PrinterConfigService,
  ) {
  }

  stopTimerIncomingKitchenOrder() {
    if (this.incomingOrderTimer$) {
      this.incomingOrderTimer$.unsubscribe();
      this.incomingOrderTimer$ = null;
    }

    if (this.incomingOrder$) {
      this.incomingOrder$.unsubscribe();
      this.incomingOrder$ = null;
    }
  }

  startTimerIncomingKitchenOrder() {
    console.log("Starting timer for incoming kitchen order");
    const user = this.authService.getUser();
    const merchant = this.ls.getMerchant();
    // assume cashier as the HOST. So store must have cashier logged-in in order to print order receipt
    if (user && user.role.toLowerCase() === "cashier") {
      if (!this.incomingOrderTimer$) {
        this.listenToIncomingKitchenOrder();
        this.incomingOrderTimer$ = timer(0, 5000).subscribe(() => this.incomingOrder$.next());
      }
    }
  }

  listenToIncomingKitchenOrder() {
    const merchant = this.ls.getMerchant();

    this.incomingOrder$
      .pipe(mergeMap(() => {
        return from([...merchant.merchantVsPrinters])
          .pipe(
            concatMap((mvp) => {
              return of(mvp).pipe(delay(mvp.printer.printerType === 'LAN' ? 1500: 1500)); // Introduce a 1-second delay for each printer
            }),
            // tap((mvp) => console.log("total printers: ", merchant.merchantVsPrinters.length, ">> trigger: ", mvp.printer.printerName, "time: ", new Date().toLocaleTimeString())),
          );
      }))
      .subscribe((mvp) => {

        if (mvp.printOrder && mvp.kitchen) {
          let posId = this.authService.getUser().userId;
          if (this.fs.isFeatureEnabled("receiptHTML")) {

            for (let type of this.prepareTypeEnum) {
              this.receiptService.getOrderReceiptHtml(
                merchant.id,
                mvp.kitchen.id,
                posId,
                type,
                mvp.printer.paperSizeType === "BIG" ? 85 : 56,
                mvp.printer.paperSizeType === "BIG" ? 570 : 380,
                (res) => {
                  if (res) {
                    this.mqs.processMessage("unprintedOrderQueue", res).then((_) => {
                      printz(
                        {
                          printerName: mvp.printer.printerName,
                          printerType: mvp.printer.printerType,
                          vendorId: mvp.printer.printerVendorId,
                          ipAddress: mvp.ipAddress,
                          macAddress: mvp.macAddress,
                          paperSizeType: mvp.printer.paperSizeType
                        },
                        [res],
                        "html"
                      );
                    });
                  } else {
                    console.error("Failed to get HTML receipt:", res);
                  }
                }
              );
            }
          } else {

            // todo: temp this.authService.getUser().userId as posId
            for (let type of this.prepareTypeEnum) {
              this.customPaymentService.getOrderReceiptUnprinted(
                merchant.id,
                mvp.kitchen.id,
                posId,
                type,
                mvp.printer.paperSizeType === "BIG" ? 45 : 32,
                (text, hasData) => {
                  if (hasData) {
                    this.mqs.processMessage("unprintedOrderQueue", text).then((_) => {
                      printz(
                        {
                          printerName: mvp.printer.printerName,
                          printerType: mvp.printer.printerType,
                          vendorId: mvp.printer.printerVendorId,
                          ipAddress: mvp.ipAddress,
                          macAddress: mvp.macAddress
                        },
                        [text],
                        "text"
                      );
                    });
                  } else {
                    console.error("Failed to get text receipt:", text);
                  }
                }
              );
            }
          }
        }

        // const merchant = this.ls.getMerchant();

        // throttle merchant.merchantVsPrinters to avoid multiple printings
        /*
              from(merchant.merchantVsPrinters)
                .pipe(
                  throttleTime(1000)
                )
                .subscribe((mvp) => {
                  if (mvp.printOrder && mvp.kitchen) {
                    console.log(`Processing printer: ${mvp.printer.printerName}`);

                    if (this.fs.isFeatureEnabled("receiptHTML")) {
                      this.receiptService.getOrderReceiptHtml(
                        merchant.id,
                        mvp.kitchen.id,
                        mvp.printer.paperSizeType === "BIG" ? 85 : 56,
                        mvp.printer.paperSizeType === "BIG" ? 570 : 380,
                        (res) => {
                          if (res) {
                            this.mqs.processMessage("unprintedOrderQueue", res).then((_) => {
                              printz(
                                {
                                  printerName: mvp.printer.printerName,
                                  printerType: mvp.printer.printerType,
                                  vendorId: mvp.printer.printerVendorId,
                                  ipAddress: mvp.ipAddress,
                                  macAddress: mvp.macAddress,
                                  paperSizeType: mvp.printer.paperSizeType
                                },
                                [res],
                                "html"
                              );
                            });
                          } else {
                            console.error("Failed to get HTML receipt:", res);
                          }
                        }
                      );
                    } else {
                      this.customPaymentService.getOrderReceiptUnprinted(
                        merchant.id,
                        mvp.kitchen.id,
                        mvp.printer.paperSizeType === "BIG" ? 45 : 32,
                        (text, hasData) => {
                          if (hasData) {
                            this.mqs.processMessage("unprintedOrderQueue", text).then((_) => {
                              printz(
                                {
                                  printerName: mvp.printer.printerName,
                                  printerType: mvp.printer.printerType,
                                  vendorId: mvp.printer.printerVendorId,
                                  ipAddress: mvp.ipAddress,
                                  macAddress: mvp.macAddress
                                },
                                [text],
                                "text"
                              );
                            });
                          } else {
                            console.error("Failed to get text receipt:", text);
                          }
                        }
                      );
                    }
                  }
                });
        */
      });
  }

  ngOnDestroy() {
    if (this.incomingOrderTimer$) {
      this.incomingOrderTimer$.unsubscribe();
    }
  }
}
